import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import FilterItem from './FilterItem';

const FilterList = SortableContainer(({ items, styles }) => {
  return (
    <ul className="filter-list">
      {items.map((filter, index) => {
        return (<FilterItem 
          key={`item-${index}`} 
          index={index}
          filter={filter}
          styles={styles}
        />);
      })}
    </ul>
  );
});

export default FilterList;
